/**
 * Display-field configurations for the merge dialog.
 * Centralised so we can add/remove fields per type without touching JSX.
 */
export const PATIENT_DISPLAY_FIELDS = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'medicaid_id', label: 'Medicaid ID' },
  { key: 'date_of_birth', label: 'DOB' },
  { key: 'gender', label: 'Gender' },
  { key: 'phone', label: 'Phone' },
  { key: 'address', label: 'Address' },
  { key: 'city', label: 'City' },
  { key: 'state', label: 'State' },
  { key: 'zip_code', label: 'ZIP' },
  { key: 'payer_type', label: 'Payer' },
  { key: 'payer_program', label: 'Program' },
  { key: 'procedure_code', label: 'Procedure' },
  { key: 'status', label: 'Status' },
];

export const EMPLOYEE_DISPLAY_FIELDS = [
  { key: 'first_name', label: 'First Name' },
  { key: 'last_name', label: 'Last Name' },
  { key: 'employee_id', label: 'Employee ID' },
  { key: 'job_title', label: 'Job Title' },
  { key: 'hire_date', label: 'Hire Date' },
  { key: 'phone', label: 'Phone' },
  { key: 'email', label: 'Email' },
  { key: 'npi', label: 'NPI' },
  { key: 'employee_medicaid_id', label: 'Medicaid ID' },
  { key: 'ssn_full', label: 'SSN' },
  { key: 'status', label: 'Status' },
];

export const fieldsForType = (mergeType) =>
  mergeType === 'patient' ? PATIENT_DISPLAY_FIELDS : EMPLOYEE_DISPLAY_FIELDS;

/**
 * Compute what the merged record will look like.
 *
 * For each display field, prefer the primary record's value; otherwise pick
 * the first non-empty value from any duplicate. Returns both the preview
 * values AND a `filledFrom` map so the UI can highlight fields that came
 * from duplicates ("filled" badges).
 */
export function computeMergedPreview(records, primaryId, displayFields) {
  if (!primaryId) return null;
  const primary = records.find((r) => r.id === primaryId);
  const dupes = records.filter((r) => r.id !== primaryId);
  const preview = {};
  const filledFrom = {};

  for (const { key } of displayFields) {
    const pVal = primary?.[key];
    if (pVal && pVal !== '') {
      preview[key] = pVal;
      filledFrom[key] = 'primary';
      continue;
    }
    const fromDupe = dupes.find((d) => d[key] && d[key] !== '');
    if (fromDupe) {
      preview[key] = fromDupe[key];
      filledFrom[key] = fromDupe.id;
    } else {
      preview[key] = '';
      filledFrom[key] = null;
    }
  }
  return { preview, filledFrom };
}
